module.exports = __webpack_public_path__ + "static/logo-centre-mere-enfant-90b0a5273a8a075dabbbaf405524e56c.svg";